import { render } from "./RadialMenu.vue?vue&type=template&id=49eb97e8&scoped=true"
import script from "./RadialMenu.vue?vue&type=script&lang=js"
export * from "./RadialMenu.vue?vue&type=script&lang=js"

import "./RadialMenu.vue?vue&type=style&index=0&id=49eb97e8&lang=scss&scoped=true"

import exportComponent from "/opt/vrc-osc-remote-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49eb97e8"]])

export default __exports__